import { useState, useEffect } from 'react';

export default function CookieBanner() {
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    const consent = localStorage.getItem('cookieConsent');
    if (consent) {
      setIsVisible(false);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookieConsent', 'accepted');
    setIsVisible(false);
  };

  const handleConfigure = () => {
    localStorage.setItem('cookieConsent', 'configured');
    setIsVisible(false);
    alert('Configuración de cookies: Esta funcionalidad se implementará próximamente.');
  };

  if (!isVisible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 bg-bg border-t border-gray-300 shadow-lg z-50 p-4 md:p-6">
      <div className="max-w-7xl mx-auto flex flex-col md:flex-row items-center justify-between gap-4">
        <p className="text-primary text-sm md:text-base">
          Usamos cookies para mejorar tu experiencia.{' '}
          <a href="#cookies" className="text-secondary underline hover:text-primary transition-colors">
            Más info
          </a>
        </p>
        <div className="flex gap-3">
          <button
            onClick={handleConfigure}
            className="px-6 py-2.5 border-2 border-primary text-primary rounded-full font-sans text-sm font-semibold hover:bg-primary hover:text-white transition-all whitespace-nowrap cursor-pointer"
          >
            Configurar
          </button>
          <button
            onClick={handleAccept}
            className="px-6 py-2.5 bg-primary text-white rounded-full font-sans text-sm font-semibold hover:bg-opacity-90 transition-all whitespace-nowrap cursor-pointer"
          >
            Aceptar
          </button>
        </div>
      </div>
    </div>
  );
}